import React, { FC, ReactNode } from "react";
import { BlueHeader } from "@app/components";
import "./blueHeaderContent.scss";
import { ScrollContext } from "@natera/platform/lib/components/scrollbar";
import classNames from "classnames";

export interface BlueHeaderContentProps {
  blueHeaderTitle: string;
  backArrowHeaderRoute?: string;
  backArrowHeaderState?: unknown;
  /** Back-arrow as a callback (e.g. step-aware navigation). Used when `backArrowHeaderRoute` is not provided. */
  backArrowHeaderButton?: () => void;
  crossHeaderRoute?: string;
  crossHeaderButton?: () => void;
  children: ReactNode;
  fullScreen?: boolean;
  /** Constrains the header and body to a 600px medium width. */
  medium?: boolean;
  /** Reserves the header's space but renders it invisible (opacity 0). */
  headerInvisible?: boolean;
  /** Replaces the desktop gradient background with a flat white surface. */
  noGradient?: boolean;
  /**
   * Additional classNames appended to the outer `blue-header-content`
   * wrapper. Existing prop-driven modifier classes are unaffected. Use
   * these as scoping hooks — target inner elements with descendant
   * selectors in SCSS (e.g. `.my-override .blue-header-content__children`).
   */
  containerClassOverrides?: string[];
}
const BlueHeaderContent: FC<BlueHeaderContentProps> = ({
  blueHeaderTitle,
  backArrowHeaderRoute,
  backArrowHeaderState,
  backArrowHeaderButton,
  crossHeaderRoute,
  crossHeaderButton,
  children,
  fullScreen = false,
  medium = false,
  headerInvisible = false,
  noGradient = false,
  containerClassOverrides,
}) => {
  return (
    <div
      className={classNames(
        "blue-header-content",
        {
          fullScreen: fullScreen,
          "blue-header-content--medium": medium,
          "blue-header-content--no-gradient": noGradient,
        },
        containerClassOverrides
      )}
    >
      <BlueHeader
        arrowRoute={backArrowHeaderRoute}
        arrowState={backArrowHeaderState}
        arrowButton={backArrowHeaderButton}
        crossRoute={crossHeaderRoute}
        crossButton={crossHeaderButton}
        title={blueHeaderTitle}
        medium={medium}
        invisible={headerInvisible}
      />
      <div className="blue-header-content__children">
        <section className="blue-header-content__scroll">{children}</section>
      </div>
    </div>
  );
};

export default BlueHeaderContent;
